import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    jobApplicantList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    jobApplicantDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const jobApplicantSlice = createSlice({
  name: 'jobApplicant',
  initialState,
  reducers: {
    getJobApplicantList: (state, action) => {
        state.jobApplicantList.requesting = true;
        state.jobApplicantList.error = null;
        state.jobApplicantList.items = [];
        state.jobApplicantList.success = false;
        state.jobApplicantList.filters = action.payload;
    },
    getJobApplicantListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.jobApplicantList.requesting = false;        
        state.jobApplicantList.items = data;
        state.jobApplicantList.success = true; 
        state.jobApplicantList.pagination.current_page = current_page;
        state.jobApplicantList.pagination.per_page = per_page;
        state.jobApplicantList.pagination.total = total;
    },
    getJobApplicanttListFail: (state, action) => {        
        state.jobApplicantList.requesting = false;
        state.jobApplicantList.error = action.payload;
    },
    getJobApplicantDetails: (state) => {
        state.jobApplicantDetails.requesting = true;
        state.jobApplicantDetails.error = null;
        state.jobApplicantDetails.data = null;
        state.jobApplicantDetails.success = false; 
    },
    getJobApplicantDetailsSuccess: (state, action) => {
        state.jobApplicantDetails.requesting = false;
        state.jobApplicantDetails.data = action.payload;
        state.jobApplicantDetails.success = true; 
    },
    getJobApplicantDetailsFail: (state, action) => {        
        state.jobApplicantDetails.requesting = false;
        state.jobApplicantDetails.error = action.payload;
    },
    doJobApplicantCreate: (state) => {
        state.jobApplicantDetails.requesting = true;
        state.jobApplicantDetails.error = null;
        state.jobApplicantDetails.data = null;
        state.jobApplicantDetails.success = false; 
    },
    doJobApplicantUpdate: (state) => {
        state.jobApplicantDetails.requesting = true;
        state.jobApplicantDetails.error = null;
        state.jobApplicantDetails.data = null;
        state.jobApplicantDetails.success = false; 
    },
    doJobApplicantDelete: (state) => {
        state.jobApplicantDetails.requesting = true;
        state.jobApplicantDetails.error = null;
        state.jobApplicantDetails.data = null;
        state.jobApplicantDetails.success = false; 
    },
    doApplyJob: (state) => {
        state.jobApplicantDetails.requesting = true;
        state.jobApplicantDetails.error = null;
        state.jobApplicantDetails.data = null;
        state.jobApplicantDetails.success = false; 
    },
    getMyJobApplicantList: (state, action) => {
        state.jobApplicantList.requesting = true;
        state.jobApplicantList.error = null;
        state.jobApplicantList.items = [];
        state.jobApplicantList.success = false;
        state.jobApplicantList.filters = action.payload;
    },
  },
})

export const { 
    getJobApplicantList, getJobApplicantListSuccess, getJobApplicantListFail,
    getJobApplicantDetails, getJobApplicantDetailsSuccess, getJobApplicantDetailsFail,
    doJobApplicantCreate, doJobApplicantUpdate, doJobApplicantDelete,
    doApplyJob, getMyJobApplicantList,
} = jobApplicantSlice.actions

export default jobApplicantSlice.reducer